import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// O SDK do Mercado Pago dispara requisições anti-fraude (fingerprint) que podem ser
// bloqueadas por alguns navegadores/ad-blockers. Isso não afeta o pagamento;
// evitamos que vire um erro visível para o usuário.
window.addEventListener("unhandledrejection", (event) => {
  const msg = String(event.reason?.message || event.reason || "");
  const stack = String(event.reason?.stack || "");
  if (
    msg === "Failed to fetch" &&
    (stack.includes("mercado") || stack.includes("mlstatic") || stack.includes("mpsdk") || stack.includes("sdk"))
  ) {
    event.preventDefault();
  }
});

// PWA: registra o service worker apenas em produção (site publicado)
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
